import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import App from './Routes/App'
import configureStore from './Redux'
import registerServiceWorker from './registerServiceWorker'

const store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>, document.getElementById('root'))
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js